"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqIntersectionInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var Monoid_1 = require("fp-ts/Monoid");
var hkt_1 = require("../hkt");
var config_1 = require("./../config");
/**
 *  @since 0.0.1
 */
exports.eqIntersectionInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.EqURI,
    intersection: function () {
        var types = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            types[_i] = arguments[_i];
        }
        return function (_name, config) { return function (env) {
            var equals = types.map(function (getEq) { return getEq(env).eq; });
            return new hkt_1.EqType(config_1.eqApplyConfig(config)({
                equals: function (a, b) { return Monoid_1.fold(Monoid_1.monoidAll)(equals.map(function (eq) { return eq.equals(a, b); })); } // TODO: optimize
            }, env, {
                equals: equals
            }));
        }; };
    }
}); });
